import React from "react"
import {Antd } from "components"
import PropTypes from "prop-types"
import ReactPlayer from 'react-player'
import * as S from './styles'

const Icon = Antd.Icon
const Modal = Antd.Modal

const ModalVideos = ({ videos, setPre, setNext, activeValue, onCancel }) => {
  const { color, title, src } = videos[activeValue] || {}
  const visible = activeValue || (activeValue === 0)

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footer={null}
      centered
      bodyStyle={{padding: 0}}
      width={typeof window !== "undefined" ? window.innerWidth : 0}
      height={typeof window !== "undefined" ? window.innerHeight : 0}
    >
      { visible && (
        <>
          <S.ModalHeader>
            <S.ModalTitle color={color}> {title}</S.ModalTitle>
          </S.ModalHeader>
          <S.ReactPlayerWrapper>
          <ReactPlayer
            playing
            controls
            width="100%"
            height={typeof window !== "undefined"  ? window.innerHeight : 0}
            url={src}
            />
          </S.ReactPlayerWrapper>
        </>
      )}
      <S.IconLeftWrapper>
      <Icon type="backward" onClick={setPre} />
      </S.IconLeftWrapper>
      <S.IconRightWrapper>
        <Icon type="forward" onClick={setNext} />
      </S.IconRightWrapper>
    </Modal>
  )
}


ModalVideos.propTypes = {
  activeValue: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  setNext: PropTypes.func.isRequired,
  setPre: PropTypes.func.isRequired,
  videos:  PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    color: PropTypes.string,
    src: PropTypes.string.isRequired,
  })).isRequired,
}


export default ModalVideos